<template>
  <div>
    <div v-if="!subject.show">
      <img :src="subject.url" alt="" />
      <p class="text">{{ subject.msg }}</p>
      <transition>
        <div class="shade" v-show="subjectIndex == active">
          <div class="tenorless">即将发布，敬请期待</div>
        </div>
      </transition>
    </div>

    <div class="text-box" v-else @click="toPaperListAll(subject.id)">
      <img :src="subject.url" alt="" />
      <p class="text-subject">{{ subject.name }}</p>
      <p class="text-name">{{ subject.briefIntroduction }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subject: {
      type: Object,
      default: () => {
        return {};
      },
    },
    subjectIndex: {
      type: Number,
      default: -1,
    },
    active: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      timeActive: 2,
      loading: false,
      paper: [],
    };
  },
  methods: {
    toDetail(id, appid) {
      this.$router.push({
        path: "/paper_detail",
        query: {
          paper_id: id,
          app_id: appid,
        },
      });
    },
    toPaperListAll(id) {
      sessionStorage.setItem('subjectId', id)
      this.$router.push({
        path: "/tfedu_common/expert",
        query: {
          id: id
        }
      });
    },
    toPaperList() {
      // 智能统练隐藏部分
      // this.$router.push({
      //   path: '/select_subject',
      //   query: {
      //     subject_type: this.subject.id,
      //     time: this.timeActive
      //   }
      // })
      // 专家测评新增部分
      this.$router.push({
        path: "/expert",
        query: {
          subject_type: this.subject.id,
          time: this.timeActive,
        },
      });
    },
    selectTimePaper(type) {
      this.loading = true;
      this.timeActive = type;
      this.getPapers(type);
    },
    getPapers(type) {
      const data = {
        subjectId: this.subject.id,
        dateType: type,
      };
      this.$HTTP
        .executePost(this.$APIS.GET_PAPERS_BY_SUBJECTID_DATETYPE, data, this)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.paper = res.data;
          }
        });
    },
  },
  created() {
    // 初始化 本周试卷信息
    this.getPapers(this.timeActive);
  },
};
</script>

<style lang="stylus" scoped>
.v-enter {
  opacity: 0;
  transform: translateY(100%);
}

.v-leave-to {
  opacity: 0;
  transform: translateY(-100%);
  // 解决页面从上往下位移问题
  position: absolute;
}

.v-enter-active, .v-leave-active {
  transition: all 0.35s ease;
}

.text {
  width: 100%;
  position: absolute;
  top: 134px;
  left: 0;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  color: #ffffff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.35);
}

.text-box {
  position: relative;
}

.text-subject {
  width: 100%;
  position: absolute;
  top: 38px;
  text-align: right;
  padding-right: 52px;
  font-size: 48px;
  font-weight: 900;
  color: #ffffff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.35);
}

.text-name {
  width: 100%;
  position: absolute;
  top: 117px;
  text-align: right;
  padding-right: 39px;
  font-size: 22px;
  font-weight: 900;
  color: #ffffff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.35);
}

img {
  width: 100%;
  height: 100%;
}

.noshade {
  width: 100%;
  height: 100%;
}

.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  .tenorless {
    width: 100%;
    height: 100%;
    line-height: 172px;
    text-align: center;
    font-size: 24px;
    color: #ff5a00;
  }
}
</style>